import { createRouter, createWebHistory } from 'vue-router'
import { ROUTES_NAMES } from './routesNames'

const {
  home,
  login,
  cardOperations,
  tickets,
  wallet,
  reporting,
  settings,
  settingsDeviceControls,
  settingsLandingPage,
  settingsServiceMode,
  reportingPhysicalCash,
  reportingBillingReport,
  certificate,
  about
} = ROUTES_NAMES

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: home,
      component: () => import('@/ui/views/HomeView.vue')
    },
    {
      path: '/login',
      name: login,
      component: () => import('@/ui/views/LoginView.vue'),
      meta: {
        layout: 'AuthLayout'
      }
    },
    {
      path: '/card-operations',
      name: cardOperations,
      component: () => import('@/ui/views/CardOperationsView.vue')
    },
    {
      path: '/tickets',
      name: tickets,
      component: () => import('@/ui/views/TicketsView.vue')
    },
    {
      path: '/wallet',
      name: wallet,
      component: () => import('@/ui/views/WalletView.vue')
    },
    {
      path: '/reporting',
      name: reporting,
      component: () => import('@/ui/views/ReportingView.vue'),
      redirect: '/reporting/physical-cash',
      children: [
        {
          path: 'physical-cash',
          name: reportingPhysicalCash,
          component: () => import('@/ui/components/reporting/SBOPhysicalCashReport.vue')
        },
        {
          path: 'billing-report',
          name: reportingBillingReport,
          component: () => import('@/ui/components/reporting/SBOBillingReport.vue')
        }
      ]
    },
    {
      path: '/settings',
      name: settings,
      component: () => import('@/ui/views/SettingsView.vue'),
      redirect: '/settings/device-controls',
      children: [
        {
          path: 'device-controls',
          name: settingsDeviceControls,
          component: () => import('@/ui/components/settings/SBODeviceControls.vue')
        },
        {
          path: 'landing-page',
          name: settingsLandingPage,
          component: () => import('@/ui/components/settings/SBOLandingPage.vue')
        },
        {
          path: 'service-mode',
          name: settingsServiceMode,
          component: () => import('@/ui/components/settings/SBOServiceMode.vue')
        }
      ]
    },
    {
      path: '/certificate',
      name: certificate,
      component: () => import('@/ui/views/CertificateView.vue')
    },
    {
      path: '/about',
      name: about,
      component: () => import('@/ui/views/AboutView.vue')
    }
  ]
})

export default router
